/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_TitleInputs */

const tr_kvkkbasvuru_title = /** @type {(inputs: Kvkkbasvuru_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK İlgili Kişi Başvuru Usulü`)
};

const en_kvkkbasvuru_title = /** @type {(inputs: Kvkkbasvuru_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Data Subject Application Procedure`)
};

const de_kvkkbasvuru_title = /** @type {(inputs: Kvkkbasvuru_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Verfahren für Anträge betroffener Personen`)
};

const ru_kvkkbasvuru_title = /** @type {(inputs: Kvkkbasvuru_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порядок обращения субъекта данных по KVKK`)
};

/**
* | output |
* | --- |
* | "KVKK Data Subject Application Procedure" |
*
* @param {Kvkkbasvuru_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_title = /** @type {((inputs?: Kvkkbasvuru_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_title(inputs)
	if (locale === "de") return de_kvkkbasvuru_title(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_title(inputs)
	return tr_kvkkbasvuru_title(inputs)
});